<!--suppress CheckEmptyScriptTag -->
<template>
  <svg class="svg-edit"
       xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 32 32">
    <polyline points="5.506 22.601 25.592 2.515 29.485 6.408 9.399 26.493"
              style="fill:none;stroke:#796e65;stroke-linecap:round;stroke-linejoin:round"
              class="stroke"/>
    <line x1="25.95953" y1="9.93307" x2="22.06665" y2="6.0402"
          style="fill:none;stroke:#796e65;stroke-linecap:round;stroke-linejoin:round"
          class="stroke"/>
    <path
      d="M9.402,26.49064c.51389-.51389-3.379-4.40675-3.89287-3.89286-.345.345-2.99408,6.88695-2.99408,6.88695S9.057,26.83562,9.402,26.49064Z"
      style="fill:#fff;stroke:#796e65;stroke-linecap:round;stroke-linejoin:round"
      class="fill"/>
    <line x1="3.84559" y1="26.26596" x2="5.73536" y2="28.1555" style="fill:none;stroke:#796e65;stroke-miterlimit:10"
          class="stroke"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgEdit'
}
</script>
